__turbopack_context__.v({
  "footer": "WhoView-module__i3BUbq__footer",
  "grid": "WhoView-module__i3BUbq__grid",
});
